import React, { Suspense } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import MainLayout from '../containers/MainLayout';
import LoadingIndicator from 'components/LoadingIndicator';

interface MainLayoutProps extends RouteProps {
  component: any;
  redirect?: string;
  isAuth?: boolean;
  requiredAuthorize?: boolean;
}

export default function ({ component: Component, redirect = '/signin', isAuth = true, ...rest }: MainLayoutProps) {
  const loggedIn = !!localStorage.getItem('token');
  return (
    <Route
      {...rest}
      render={(matchProps) => {
        if (!isAuth || loggedIn) {
          // eslint-disable-next-line no-param-reassign
          matchProps.location.state = { redirectPath: null };
          // react-router 5 giữ nguyên instance khi điều hướng giữa 2 URL cùng <Route>
          // (vd /products/A -> /products/B). Các trang fetch theo URL lúc mount (saga
          // RESTART_ON_REMOUNT) sẽ hiển thị dữ liệu cũ. key theo pathname buộc remount ->
          // refetch. Trang list dạng query-string (/thuong-hieu = AllBrandPage) đổi ?name=
          // trên cùng pathname nên phải kèm search vào key.
          const remountKey =
            matchProps.location.pathname === '/thuong-hieu'
              ? matchProps.location.pathname + matchProps.location.search
              : matchProps.location.pathname;
          return (
            <MainLayout>
              <Suspense fallback={<LoadingIndicator />}>
                <Component key={remountKey} {...matchProps} />
              </Suspense>
            </MainLayout>
          );
        }
        return (
          <Redirect
            to={{
              pathname: redirect,
              state: { referrer: matchProps.location, redirectPath: redirect },
            }}
          />
        );
      }}
    />
  );
}
